import rawConfig from '../../data/advertising.json';
import { parseAdvertisingConfig } from './config';

export const advertisingConfig = parseAdvertisingConfig(rawConfig);
